import Mark from "./Mark.ts";
import MarkText from "../components/MarkText.ts";
import {Container, Graphics, Sprite, Text, TextStyle} from "pixi.js";
import DecodingModel from "../models/DecodingModel.ts";
import IMark from "../interfaces/IMark.ts";
import RhColors from "@/models/RhColors.ts";

export default class SoundOfZMark extends Mark implements IMark
{
    public get targetX():number
    {
        if(this._targetX == undefined)
        {
            if(this.targetTextField)
            {
                this._targetX = 0;
            }
            else
            {
                this._targetX = 0;
            }
        }
        return this._targetX;
    }

    public get targetY():number
    {
        if(this._targetY == undefined)
        {
            if(this.targetTextField)
            {
                this._targetY = this.targetTextField.y;
            }
            else
            {
                this._targetY = 0;
            }
        }
        return this._targetY;
    }

    constructor(targetTextField?:MarkText, color=RhColors.MARK_PRIMARY)
    {
        super(color);
        this.targetTextField = targetTextField;
        this._init();
    }

    private _init():void
    {
        if(this.targetTextField)
        {
            this.parentTarget = this.targetTextField;
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        const text = "z";
        const style = new TextStyle({
            fontFamily: DecodingModel.getInstance().fontFamily,
            fontSize: 100,
            fill: color,
            align: 'center'
        });
        let mark = new Text({text:text, style:style});
        //const metrics = TextMetrics.measureText(text, style);
        if(this.targetTextField)
        {
        }
        else
        {
            mark.anchor.set(.5, .5);
        }
        this.markWidth = mark.width;
        this.markHeight = mark.height;
        mark.visible = visible;
        this.addChild(mark);
        //mark.cacheAsBitmap = true;
        return mark;
    }

    public override create():void
    {
        this.createMarks();
    }

    public createMarks():void
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

}